import { toLabelAndValue } from "neetocist";
import { pluck } from "ramda";

import { UNWANTED_FAMILIES } from "./constants";

export const defaultFilterOptions = font =>
  !UNWANTED_FAMILIES.includes(font.family);

export const sortAndFormatFonts = availableFonts =>
  pluck("family", availableFonts)
    .sort((a, b) => a.localeCompare(b))
    .map(toLabelAndValue);
